(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Mfa', '$window', '$translate'];

    function UserManagementDetailController ($stateParams, User, Mfa, $window, $translate) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.disableMfa = disableMfa;

        vm.load($stateParams.login);

        function load (login) {
            User.getAdministrationDetail({login: login}, function(result) {
                vm.user = result;
                Mfa.managedStatus(login).then(function(status) { vm.mfaStatus = status; })
                    .catch(function() { vm.mfaStatus = null; });
            });
        }

        function disableMfa() {
            if (vm.mfaBusy || !$window.confirm($translate.instant('mfa.adminConfirm', {login: vm.user.login}))) { return; }
            vm.mfaBusy = true;
            vm.mfaError = null;
            Mfa.disableForUser(vm.user.login).then(function(status) {
                vm.mfaStatus = status;
                vm.mfaSuccess = true;
            }).catch(function() { vm.mfaError = true; }).finally(function() { vm.mfaBusy = false; });
        }
    }
})();
